export default function setRatingCss(p, rating) {
  var is = p.find('li');

  for (var i = 0; i < 5; i++) {
    if (i + 1 <= rating) {
      $(is[i]).addClass('selected');
    }
    else {
      $(is[i]).removeClass('selected');
    }
  }
}